import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Chift\GetCompanyIntegrationsListController::__invoke
* @see app/Http/Controllers/Chift/GetCompanyIntegrationsListController.php
* @route '/api/company/{company}/chift/integrations-list'
*/
const GetCompanyIntegrationsListController = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetCompanyIntegrationsListController.url(args, options),
    method: 'get',
})

GetCompanyIntegrationsListController.definition = {
    methods: ["get","head"],
    url: '/api/company/{company}/chift/integrations-list',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Chift\GetCompanyIntegrationsListController::__invoke
* @see app/Http/Controllers/Chift/GetCompanyIntegrationsListController.php
* @route '/api/company/{company}/chift/integrations-list'
*/
GetCompanyIntegrationsListController.url = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return GetCompanyIntegrationsListController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Chift\GetCompanyIntegrationsListController::__invoke
* @see app/Http/Controllers/Chift/GetCompanyIntegrationsListController.php
* @route '/api/company/{company}/chift/integrations-list'
*/
GetCompanyIntegrationsListController.get = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetCompanyIntegrationsListController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Chift\GetCompanyIntegrationsListController::__invoke
* @see app/Http/Controllers/Chift/GetCompanyIntegrationsListController.php
* @route '/api/company/{company}/chift/integrations-list'
*/
GetCompanyIntegrationsListController.head = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetCompanyIntegrationsListController.url(args, options),
    method: 'head',
})

export default GetCompanyIntegrationsListController